import './copper/style';
import FormStructure from './copper/form_structure';

export default FormStructure;